/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ProgressManagerPlayEvent extends alm.event.Event {

		public static CHANGE:string = "ProgressManagerPlayEvent.CHANGE";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, isPlaying:boolean) {
			super(eventType, target);
			this.isPlaying = isPlaying;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsPlaying():boolean {
			return this.isPlaying;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isPlaying:boolean;
	}
}
